import * as React from "react";
import { Button, Modal, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { FetchWithAuth } from "digimaker-ui/util";

interface Props {
  selected: any[];
  afterAction: (refresh: boolean) => void;
}

const BulkDelete: React.FC<Props> = ({ selected, afterAction }) => {
  const [loading, setLoading] = React.useState(false);

  if (!selected || selected.length === 0) {
    return null;
  }

  const handleDelete = () => {
    Modal.confirm({
      title: `Delete ${selected.length} student${selected.length > 1 ? "s" : ""}?`,
      content: "This cannot be undone.",
      okText: "Delete",
      okType: "danger",
      onOk: async () => {
        setLoading(true);
        let failed = 0;
        const ids = selected.map((item) => item.id).join(",");
        try {
          await FetchWithAuth("content/delete?cid=" + ids + "&type=student");
        } catch {
          failed++;
        }
        setLoading(false);
        if (failed > 0) {
          message.error(`${failed} deletion(s) failed.`);
        } else {
          message.success(
            `Deleted ${selected.length} student${selected.length > 1 ? "s" : ""}.`,
          );
        }
        afterAction(true);
      },
    });
  };

  return (
    <Button
      danger
      icon={<DeleteOutlined />}
      loading={loading}
      onClick={handleDelete}
    >
      Delete selected ({selected.length})
    </Button>
  );
};

export default BulkDelete;
